import React from 'react'

export default function MeetOur() {
  return (
    <section className="leadership-area pt-135 pb-140 bg_disable">
    <div className="container">
      <div className="row align-items-end">
        <div className="col-sm-8">
          <div className="section-title text-start wow fadeInRight">
            <span className="short-title mt-0">Leadership</span>
            <h2 className="mb-0">Meet our leadership team</h2>
          </div>
        </div>
        <div className="col-sm-4 text-end">
          {/* <a href="#" className="theme-btn theme-btn-outlined wow fadeInLeft">
            {" "}
            see more <i className="arrow_carrot-right " />
          </a> */}
        </div>
      </div>
      <div className="row pt-65 gy-md-0 gy-4">
        <div className="col-lg-4">
          <div
            className="single-leadership-widget wow fadeInUp "
            data-wow-delay="0.1s"
          >
            <a href="#">
              <img src="img/leadership/img-1.png" alt="leader-1" />
              <div className="leader-info">
                <h5>Eldridge Robles</h5>
                <p>Co-Founder, Conis</p>
              </div>
            </a>
          </div>
        </div>
        <div className="col-lg-4">
          <div
            className="single-leadership-widget wow fadeInUp "
            data-wow-delay="0.3s"
          >
            <a href="#">
              <img src="img/leadership/img-2.png" alt="leader-2" />
              <div className="leader-info">
                <h5>Eldridge Robles</h5>
                <p>Co-Founder, Conis</p>
              </div>
            </a>
          </div>
        </div>
        <div className="col-lg-4">
          <div
            className="single-leadership-widget wow fadeInUp "
            data-wow-delay="0.5s"
          >
            <a href="#">
              <img src="img/leadership/img-3.png" alt="leader-3" />
              <div className="leader-info">
                <h5>Eldridge Robles</h5>
                <p>Co-Founder, Conis</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  )
}
